
/* styles */
require("!!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-4ab492a4&scoped=true!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./LoggedInHeader.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./LoggedInHeader.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-4ab492a4!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./LoggedInHeader.vue"),
  /* scopeId */
  "data-v-4ab492a4",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/global/LoggedInHeader.vue
// module id = 590
// module chunks = 0